import {Observable} from 'rxjs/Observable';
import {filterOptionsFactory} from 'viewOptions/factories';
import * as ViewOptionsActions from 'viewOptions/actions';
import * as ResourceActions from 'resources/actions';
import * as PrizeServiceApi from 'api/prize-service';
import * as ResourceApi from 'api/resources';
import * as EntriesActions from './actions';
import {addManualEntry} from "../../api/prize-service";
import {downloadReport} from "../../api/prize-service";
import * as ReportApi from 'api/reports';
import {createResourceSelector} from "../../resources/selectors";
import {clone, toggleSort} from "../../utils/DBUtils";
import moment from "moment";
import {submitManualEntrySuccessAction} from "./actions";
import {selectWinnersSuccessAction} from "./actions";
import {sortOptionsFactory} from "../../viewOptions/factories";
import {receivedManualEntryBreakSearchResultsSuccess} from "./actions";

const requestEntriesEpic = (action$, store) => action$.ofType(
  EntriesActions.Types.REQUEST_ENTRIES,
  ResourceActions.Types.UPDATE_PAGE_NUMBER_FOR_RESOURCE,
  ViewOptionsActions.Types.TOGGLE_SORT_FOR_RESOURCE
)
  .filter(action => {
    if (action.type === EntriesActions.Types.REQUEST_ENTRIES) {
      return true;
    } else {
      return action.resourceType === ResourceApi.Types.PrizeEntry && action.params.winnersOnly === false;
    }
  })
  .mergeMap(action => {
    const {currentPrizeId} = store.getState().listEntries;
    const prizeId = action.prizeId || currentPrizeId;

    // null sortOptions offloads sorting to 'resources' epics
    const sortOptions = null;

    return Observable.of(
      // fetch a PrizeEntry page, plus their Prize.
      ResourceActions.getResourceAction(ResourceApi.Types.Prize, prizeId),
      ResourceActions.getResourcePageAction(
        ResourceApi.Types.PrizeEntry,
        20,
        action.page || 1,
        sortOptions,
        filterOptionsFactory({
          filters: [{field: 'prizeId', value: prizeId}]
        })
      )
    );
  });

const receivedPrizeEpic = (action$, store) => action$.ofType(ResourceActions.Types.RECEIVED_RESOURCE)
  .filter(action => {
    const {fetchingPrize} = store.getState().listEntries;
    return fetchingPrize && action.resourceType === ResourceApi.Types.Prize;
  })
  .mapTo(EntriesActions.receivedPrizeAction());

const receivedEntriesEpic = (action$, store) => action$.ofType(ResourceActions.Types.RECEIVED_RESOURCE_PAGE)
  .filter(action => {
    const {fetchingEntries} = store.getState().listEntries;
    return fetchingEntries && action.resourceType === ResourceApi.Types.PrizeEntry;
  })
  .mapTo(EntriesActions.receivedEntriesAction());

const selectWinnersEpic = action$ => action$.ofType(EntriesActions.Types.SUBMIT_SELECT_WINNERS)
  .mergeMap(action => (
    PrizeServiceApi.selectWinners(action.prizeId)
      .mapTo(EntriesActions.selectWinnersSuccessAction(action.prizeId))
      .catch(error => {
        if (error.status === 403) {
          console.error('User account has insufficient permissions.');
        }

        return Observable.of(EntriesActions.selectWinnersErrorAction());
      })
  ));

const downloadReportEpic = action$ => action$.ofType(EntriesActions.Types.DOWNLOAD_REPORT)
  .mergeMap((action) => {

    console.log("DOWNLOAD REPORT");

    // other report epics look like this:
    // ResourceApi.download(ReportApi.PrizeEntriesReport, action.args)
    //   .map(xhr => AnalyticsActions.downloadReportSuccess(action.reportType))
    //   .catch(error => Observable.of(AnalyticsActions.downloadReportError(action.reportType, error.response)))

    // return PrizeServiceApi.downloadReport(action.prizeId)
    return ResourceApi.download(ReportApi.ReportTypes.PrizeEntriesReport, {prizeId: action.prizeId})
      .mapTo(EntriesActions.downloadReportSuccessAction(action.prizeId))
      .catch(error => {
        if (error.status === 403) {
          console.error('User account has insufficient permissions.');
        }

        return Observable.of(EntriesActions.downloadReportErrorAction(action.prizeId));
      })

  });


const refreshEntriesEpic = action$ => action$.ofType(EntriesActions.Types.SELECT_WINNERS_SUCCESS)
  .map(action => EntriesActions.requestEntriesAction(action.prizeId));

const submitManualEntryEpic = (action$, store) => action$.ofType(EntriesActions.Types.SUBMIT_MANUAL_ENTRY)
    .mergeMap((action) => {
        const {currentPrizeId} = store.getState().listEntries;

        const getPrize = createResourceSelector(currentPrizeId);
        const prize = getPrize(store.getState().resources) || {};

        let manualEntry = clone(action.data);
        delete manualEntry.type;
        manualEntry.prizeId = prize.id;
        manualEntry.lang = prize.lang;
        manualEntry.dateOfBirth = moment(manualEntry.dateOfBirth).unix();

        return addManualEntry(manualEntry)
            .mergeMap(() => Observable.of(
                submitManualEntrySuccessAction(),
                selectWinnersSuccessAction(currentPrizeId)
            ))
            .catch((err) => Observable.of({type: "ERROR", error: err}));
    });

const searchBreaksEpic = (action$) => action$.ofType(EntriesActions.Types.UPDATE_MANUAL_ENTRY_BREAK_SEARCH)
    .throttleTime(500)
    .mergeMap((action) => {
        const sortOptions = sortOptionsFactory('_created');
        sortOptions.sorts = toggleSort(sortOptions.sorts, '_created');

        const filterOptions = filterOptionsFactory({
            filters: [
            ]
        });

        return ResourceApi.searchResources(ResourceApi.Types.Break, action.text, sortOptions, filterOptions, 10)
            .map(({response: {object}}) => {
                return receivedManualEntryBreakSearchResultsSuccess(object);
            }).catch((error) => {
                console.error(error);
                // in case a search fails this epic won't break
                return receivedManualEntryBreakSearchResultsSuccess([]);
            });
    });

export default [
  requestEntriesEpic,
  receivedPrizeEpic,
  receivedEntriesEpic,
  selectWinnersEpic,
  refreshEntriesEpic,
  submitManualEntryEpic,
  downloadReportEpic,
  searchBreaksEpic
];



// WEBPACK FOOTER //
// ./public/pages/ListEntries/epics.js